import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const getNetProfitLoss = async (communityId: string | number, fiscalYear: string | number) => {
  return await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/net-profit-loss`);
};

const useGetNetProfitLoss = ({
  communityId,
  fiscalYear,
  queryParams
}: 
{
  communityId?: string | number,
  fiscalYear?: string | number,
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}) =>
  useQuery({
    queryKey: ["net-profit-loss", communityId, fiscalYear],
    queryFn: () => getNetProfitLoss(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    enabled: !!communityId && !!fiscalYear,
    ...queryParams
  });

export default useGetNetProfitLoss;